export const toAbsoluteRedirectUrl = (redirectTo) => {
  if (typeof redirectTo === "string" && /^https?:\/\//i.test(redirectTo)) {
    return redirectTo;
  }
  const path = typeof redirectTo === "string" && redirectTo.startsWith("/") ? redirectTo : "/";
  return `${window.location.origin}${path}`;
};

export const appendRedirectUrl = (authUrl, redirectTo) => {
  const absoluteRedirectUrl = toAbsoluteRedirectUrl(redirectTo);
  try {
    const url = new URL(authUrl, window.location.origin);
    url.searchParams.set("redirect_url", absoluteRedirectUrl);
    return url.toString();
  } catch (error) {
    const separator = authUrl.includes("?") ? "&" : "?";
    return `${authUrl}${separator}redirect_url=${encodeURIComponent(absoluteRedirectUrl)}`;
  }
};
